import React from 'react'
import UserNav from '../../Components/Nav/UserNav'

function Wishlist() {
    return (
        <div className='container-fluid'>
        <div className="row">
            <div className='col-md-2'>
                    <UserNav />
            </div>
            <div className='col'>
                    user wishlist Page
            </div>
        </div>
            
        </div>
    )
}

export default Wishlist
